import { render, staticRenderFns } from "./businessYG.vue?vue&type=template&id=004e2f8a&scoped=true"
import script from "./businessYG.vue?vue&type=script&lang=ts"
export * from "./businessYG.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004e2f8a",
  null
  
)

export default component.exports